// extracted by mini-css-extract-plugin
export default {"criteria":"Password-criteria","criteriaLabel":"Password-criteriaLabel"};